module.exports = __webpack_public_path__ + "img/alert_copy.0674ce4f.svg";